"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_select_1 = __importDefault(require("react-select"));
const inline_colors_1 = require("inline-colors");
/**
 * @deprecated use `InputSelectNative` or `Select` instead
 */
const SingleSelect = ({ input, ...rest }) => ((0, jsx_runtime_1.jsx)(react_select_1.default, { ...input, ...rest, styles: {
        control: (baseStyles) => ({
            ...baseStyles,
            border: 'none',
            borderRadius: '0',
            borderBottom: '1px solid black',
            margin: 0,
            padding: '6px 0',
            textAlign: 'left',
        }),
        container: (baseStyles) => ({
            ...baseStyles,
            textAlign: 'left',
        }),
        singleValue: (baseStyles) => ({
            ...baseStyles,
            color: inline_colors_1.INLINE_COLORS.blackBase,
        }),
        menu: (baseStyles) => ({
            ...baseStyles,
            borderRadius: 0,
        }),
        indicatorSeparator: (baseStyles) => ({
            ...baseStyles,
            display: 'none',
        }),
        dropdownIndicator: (baseStyles) => ({
            ...baseStyles,
            color: inline_colors_1.INLINE_COLORS.blackBase,
        }),
    } }));
exports.default = SingleSelect;
